export enum ReportTokenType {
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  ADMINISTRATIVE_SYNTHETIC = 'ADMINISTRATIVE_SYNTHETIC',
  CHECKLIST = 'CHECKLIST',
  BANK_SLIP = 'BANK_SLIP',
  VEHICLE_STICKER = 'VEHICLE_STICKER',
}

export interface ReportTokenRequest {
  params: string;
  reportType: ReportTokenType;
}

export interface ReportTokenResponse {
  params: string;
  reportType: ReportTokenType;
  token: string;
}
